import ApiBase from '../ApiBase';

class Exhibitors extends ApiBase {
    route = '/admin/exhibitors';
}

export default new Exhibitors();
